import { connect } from 'react-redux';

import { DeleteButton } from 'modules/layout';

import { selectItemPending } from '../services/selectors';
import { deleteImageMapsRequest } from '../services/actions';

export default connect(
    (state, { id }) => ({
        pending: selectItemPending(state, { id }),
    }),
    (dispatch, { id }) => ({
        handleDelete: () => {
            dispatch(deleteImageMapsRequest(id));
        },
    }),
)(DeleteButton);
